import {EmptyColumn,SeatColumn} from "./seat-layout.component"
import React from 'react';
import { isValid } from "../../utils/utilities";

export const generateSeatLayout=(seatGrid,maximumRowNumberByColumn,col_count)=>{
    const seatArray =[]
    let seatObject;
    for (var rowIndex = 1;rowIndex<=col_count;rowIndex++){
        const tableRowData = [];
        let isColumnEmpty = false;
        let rowCount=isValid(maximumRowNumberByColumn[rowIndex])&&isValid(maximumRowNumberByColumn[rowIndex].maximumRowNumber)?maximumRowNumberByColumn[rowIndex].maximumRowNumber:0;
        for (var columnIndex = 1;columnIndex<=rowCount;columnIndex++){
            if(seatGrid[columnIndex] !== undefined)
            {
                seatObject = seatGrid[columnIndex][rowIndex]
                isColumnEmpty = (isColumnEmpty && seatObject === undefined);
                let emptySeatClass = 'seatGap';
                if (!isValid(seatObject)) {
                    if (rowIndex-1>0 && rowIndex+1<=col_count) {
                        let prevSeatObject = seatGrid[columnIndex][rowIndex-1];
                        let nextSeatObject = seatGrid[columnIndex][rowIndex+1];

                        if ((isValid(prevSeatObject) && isValid(nextSeatObject)) && (prevSeatObject.props.object.sleeper == true && nextSeatObject.props.object.sleeper == true)) {
                            emptySeatClass = 'sleeperGap';
                        }
                        else {
                            emptySeatClass = 'seatGap';
                        }
                    }
                }
                let seat = seatObject === undefined ? <div className={emptySeatClass} key={`empty-${rowIndex}-${columnIndex}`}></div> : seatObject;
                tableRowData.push(seat)
            }
        }
        if(isColumnEmpty){
            seatArray.push(<EmptyColumn seats={tableRowData} key={rowIndex} />);
        }else{
            seatArray.push(<SeatColumn seats={tableRowData} key={rowIndex} />);
        }
    }
    return seatArray
}
